import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import backendUrl from "../BackendUrl";
import "../styles/ActiveOffers.css"; // Import CSS file

const ActiveOffers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/offers/get-offer`);
        setOffers(response.data);
      } catch (error) {
        console.error("Error fetching offers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  return (
    <div className="active-offers-container">
      <h1 className="offers-title">Available Offers</h1>
      {loading ? (
        <p className="loading-text">Loading offers...</p>
      ) : offers.length === 0 ? (
        <p className="no-offers-text">No offers available.</p>
      ) : (
        <div className="offers-wrapper">
          {offers.map((offer) => (
            <div key={offer._id} className="offer-card">
              {offer.offerImg && (
                <img src={offer.offerImg} alt={offer.offer} className="offer-image" />
              )}
              <h2 className="offer-title">{offer.offer}</h2>
              <p className="offer-description">{offer.description}</p>
              <p className="offer-discount">{offer.percent}% Off</p>
              <p className="offer-expiry">
                Expires: {new Date(offer.expires).toLocaleDateString()}
              </p>
              {/* Build & Price Button */}
              <div className="build-price-container">
                <Link to="/buildnprice" className="build-price-button">
                  Build & Price
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActiveOffers;